// extracted by mini-css-extract-plugin
module.exports = {"modal":"GoalModal_modal__38Sgx","inner":"GoalModal_inner__1X2YC","btnWrapper":"GoalModal_btnWrapper__33y-V","widthSpacer":"GoalModal_widthSpacer__3TiYZ"};